<div class="content" role="main">

<!--<img src="https://www.xeotek.com/wp-content/uploads/2020/05/Screen_Alu_KaDeck_200orange_04x-1024x768.png" alt="KaDeck Desktop" style="width: 260px" />-->
  <h1 class="txtgradientt1">Start you KaDeck Desktop download</h1>
<span class="subtopic">
  Your download includes a <b>free 7-day trial</b> license for KaDeck Professional.
</span>



  <div class="card-container" style="margin-top: 60px;">
    <a class="card download" target="_blank" rel="noopener" [href]="urlwin">

      <mat-icon style="margin-right: 10px">save_alt</mat-icon>
      <span>Windows</span>

    </a>

    <a class="card download" target="_blank" rel="noopener" [href]="urlmac">
      <mat-icon style="margin-right: 10px">save_alt</mat-icon>

      <span>Mac</span>

    </a>

    <a class="card download" target="_blank" rel="noopener" [href]="urllinux">
      <mat-icon style="margin-right: 10px">save_alt</mat-icon>

      <span>Linux</span>

    </a>
    <p style="margin: 40px 0 0; font-size: 15px; text-align: center"><b style="padding-bottom: 20px; display: inline-block">Looking for KaDeck Desktop Free</b>?<br>After the 7 days trial license your version will be automatically converted to KaDeck Desktop Free.<br/>No need to take any action.</p>

<!--    <p style="margin: 40px 0 50px; font-size: 15px; text-align: center"><b>You have already purchased a license?</b><br>If you already have a license, you can activate KaDeck Desktop Professional with it.</p>-->

  </div>


  <h2 style="margin-top: 100px;" class="h1style">Don't leave yet!  Three steps to get you started.</h2>
  <p>In about 3 minutes you' ll be ready for your data journey</p>

  <div class="card-container">
    <div class="step">
      <h3>1. Download & unzip</h3>
      <p class="desc">Unzip the downloaded file</p>
      <img src="assets/Download.jpg" alt="Start and register">
      <p class="details">Select the download for your operating system. After downloading KaDeck Desktop you need to unzip the file.</p>

    </div>
    <div class="step">
      <h3>2. Start & register</h3>
      <p class="desc">Open KaDeck and fill in your details</p>
      <img src="assets/Form_Register.jpg" alt="Start and register">
      <p class="details">Double click the executable after unpacking to start KaDeck - no installation is necessary. If you need help starting it, <a href="https://support.xeotek.com/hc/en-us/articles/360015585420-Starting-KaDeck-Desktop-on-Linux-Mac-Win" target="_blank">read our article</a>.</p>

    </div>

    <div class="step">
      <h3>3. Connect</h3>
      <p class="desc">Create a connection</p>
      <img src="assets/StartConnection.jpg" alt="Create a connection">

      <p class="details"><a href="https://support.xeotek.com/hc/en-us/categories/360002602340-Connections" target="_blank">Create a connection</a> to Apache Kafka or Amazon Kinesis and start your data journey.</p>

    </div>

  </div>

  <h2 style="margin-top: 100px;" class="h1style">Learn more</h2>
  <p>Here are some links to help you get started:</p>

  <a class="cta fill" href="https://support.xeotek.com/hc/en-us">View our help center articles</a>
</div>
